import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]
  
  connect() {
    // Initialize search state from URL if present
    const urlParams = new URLSearchParams(window.location.search)
    this.currentSearch = urlParams.get("search") || ""
    
    // Set initial search input value if there is a search parameter in the URL
    if (this.hasInputTarget && this.currentSearch) {
      this.inputTarget.value = this.currentSearch
    }
    
    // Listen for frame loads to maintain search context during pagination
    document.addEventListener("turbo:frame-load", (event) => {
      if (event.target.id === "documents") {
        // Update pagination links to maintain search
        if (this.currentSearch) {
          const links = event.target.querySelectorAll(".bynn_pagination a")
          links.forEach(link => {
            const url = new URL(link.href)
            url.searchParams.set("search", this.currentSearch)
            link.href = url.toString()
          })
        }
      }
    })
  }
  
  // Handle key press in the search input (to capture Enter key)
  keydown(event) {
    // Only trigger search on Enter key (key code 13)
    if (event.keyCode === 13) {
      event.preventDefault() // Prevent form submission
      this.executeSearch()
    }
  }
  
  // Execute search when search button is clicked
  search() {
    this.executeSearch()
  }
  
  // Common search execution logic
  executeSearch() {
    const query = this.inputTarget.value.trim()
    
    // Update search state
    this.currentSearch = query
    
    // Build the URL with search parameters
    let url = new URL(window.location.href)
    
    if (query && query.length > 0) {
      url.searchParams.set("search", query)
    } else {
      url.searchParams.delete("search")
      this.currentSearch = ""
    }
    
    // Reset to page 1 when search changes
    url.searchParams.delete("page")
    
    // Use Turbo navigation instead of full page reload
    Turbo.visit(url.toString(), { action: "replace" })
  }
}